<div
  class="side-panel-backdrop"
  [class.is-visible]="sidePanelService.isOpen()"
  (click)="onBackdropClick()"
  aria-hidden="true"
></div>

<aside
  class="side-panel"
  [class.is-open]="sidePanelService.isOpen()"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="sidePanelService.config()?.title ?? 'Side panel'"
  (keydown)="onPanelKeydown($event)"
  tabindex="-1"
>
  <header class="side-panel-header">
    <div class="side-panel-title-wrap">
      @if (sidePanelService.config()?.icon || sidePanelService.config()?.iconClass) {
        <span
          class="side-panel-icon"
          [class]="sidePanelService.config()?.iconClass ?? ''"
          aria-hidden="true"
        >
          {{ sidePanelService.config()?.icon }}
        </span>
      }

      <h2 class="side-panel-title">{{ sidePanelService.config()?.title }}</h2>
    </div>

    <button type="button" class="side-panel-close" (click)="onCloseClick()" aria-label="Close panel">
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
      </svg>
    </button>
  </header>

  <div class="side-panel-body">
    <ng-container #contentHost />
  </div>
</aside>
